<template>
	<v-row justify="center">
		<v-col
			cols="4"
			md="3"
			:class="['d-flex justify-center align-center pa-1']"
			v-for="item in items"
		>
			<router-link
				:to="{
					name: item.to,
				}"
				style="text-decoration: none;"
			>
				<SimpleCard
					:category="item"
					class="animate__animated animate__fadeIn"
				></SimpleCard>
			</router-link>
		</v-col>
	</v-row>
</template>

<script>
import SimpleCard from "@/components/Category/SimpleCard";
import axios from "axios";

export default {
	components: {
		SimpleCard,
	},

	data() {
		return {
			items: [
				{
					name: "Vinílicas",
					color: "pink",
					to: "Vinilicas",
					img: "https://i.mkt.lu/cont/218414/280/240/pintura.jpg",
				},
				{
					name: "Impermeabilizantes",
					color: "orange",
					to: "Impermeabilizantes",
					img:
						"https://www.materialesjerez.com.mx/wp-content/uploads/2019/10/Impermeabilizante-fotosensible.png",
				},
				{
					name: "Línia Industrial",
					color: "purple",
					to: "Vinilicas",
					img:
						"https://st.depositphotos.com/1779390/1312/i/600/depositphotos_13120941-stock-photo-painting-metal.jpg",
				},
				{
					name: "Aerosoles",
					color: "blue",
					to: "Aerosoles",
					img:
						"https://assets.leroymerlin.es/is/image/lmes/82601547-0112/spray-mtn-matte-varnish-300ml.jpg?$lmesBgTablet$&align=0,0&fit=crop,1&wid=445&hei=480",
				},
				{
					name: "Línea Automotiva",
					color: "red",
					to: "Vinilicas",
					img:
						"https://http2.mlstatic.com/D_NQ_NP888035-MLA40694915611_022020-B.webp",
				},
				{
					name: "Línea Maderas",
					color: "accent",
					to: "Vinilicas",
					img:
						"https://i.pinimg.com/originals/b8/c7/6e/b8c76e112122af19db55e3574429fb8d.jpg",
				},
				{
					name: "Esmaltes",
					color: "pink",
					to: "Esmaltes",
					img:
						"https://http2.mlstatic.com/D_NQ_NP962999-MLA41376321848_042020-B.webp",
				},
			],
		};
	},

	created() {
		// this.get();
	},

	methods: {
		async get() {
			try {
				let response = await axios.get(
					`${process.env.VUE_APP_DOMAIN}/json/store/home/product_lines.json`
				);

				console.log(response.data);
			} catch (e) {
			} finally {
			}
		},
	},
};
</script>

<style lang="css" scoped></style>
